export default __webpack_public_path__ + "static/media/selfie.76a2c1b0.png";